import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  base: {},
  header: {
    marginBottom: 20,
    flexDirection: 'row',
    alignItems: 'flex-start',
  },
  paddingRight: {
    paddingRight: 10,
  },
  heading: {
    flex: 1,
    flexShrink: 1,
  },

  body: {
    marginTop: 5,
  },
  bodyText: {
    flexShrink: 1,
  },
});
